import { render, staticRenderFns } from "./IntroSlide2.vue?vue&type=template&id=bff269f8"
import script from "./IntroSlide2.vue?vue&type=script&lang=js"
export * from "./IntroSlide2.vue?vue&type=script&lang=js"
import style0 from "./IntroSlide2.vue?vue&type=style&index=0&id=bff269f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports